// GENERATED FROM DART FILES. DO NOT EDIT MANUALLY.

let summaryParams = `

  name
  currency
  debtEntries {
    debtor
    creditor
    amount
  }
  amount
  totalExpenses
  updatedAt
  
`;

let expenseParams = `

      amount
      currency
      date
      debt
      description
      expenseType
      id
      itemizedData {
        owner
        additionalCharges {
          name
          value
          isDiscount
        }
        items {
          id
          assignees {
            participants
            quantity
          }
          name
          price
          quantity
        }
        receiptAvailable
      }
      participants
      payerAmounts
      payers
      portions
      rate
  
`;

let groupParams = `

  currency
    expenses {
      ${expenseParams}
    }
    groupSettings {
      simplify
    }
    id
    mv
    updatedAt
    name
    numberOfPastSplits
    participants
    assignedUsers {
      participant
      userId
    }
    
    summary {
      ${summaryParams}
    }
    
    settlement {
      totalSpent
      debtMatrix
      linkedParticipantGroups {
        participants
      }
      settledEntries {
        amount
        comment
        date
        id
        payee
        payer
      }
    }
  
`;

let userDataParams = `

    paybackMethods {
      type
      data
    }
    preferredName
    preferredCurrency
    username
    isPro
    maxFreeScans
    scanCount
    groups {
      ${groupParams}
    }
  
`;

export const queries = {
  editExpense: `

  mutation EditExpense($expenseId: String!, $groupId: String!, $input: EditExpenseInput!, $participants: [String] ) {
  editExpense(expenseId: $expenseId, groupId: $groupId, input: $input, participants: $participants) {
    ${groupParams}
  }
}
  
`,
  feedback: `

  mutation Feedback($message: String!, $email: String) {
  feedback(message: $message, email: $email)
}
  
`,
  updateDeviceInfo: `

  mutation UpdateDeviceInfo($input: DeviceInfoInput! ) {
    updateDeviceInfo(input: $input)
}
  
`,
  migrateGroups: `

  mutation MigrateGroups($groupString: String! ) {
    migrateGroups(groupString: $groupString)
}
  
`,
  claimMagicLink: `

  mutation ClaimMagicLink($token: String!) {
    claimMagicLink(token: $token) {
      ${groupParams}
    }
  }
  
`,
  associateImageWithExpense: `

  mutation AssociateImageWithExpense($groupId: String!, $expenseId: String!,  $imageId: String! ) {
  associateImageWithExpense(groupId: $expenseId, expenseId: $groupId, imageId: $imageId) {
    ${groupParams}
  }
}
  
`,
  removeGroup: `

mutation RemoveGroup($groupId: String!) {
  removeGroup(groupId: $groupId) {
  ${userDataParams}
  }
}

`,
  closePermanently: `

mutation ClosePermanently {
  closePermanently {
  ${userDataParams}
  }
}

`,
  updateUserData: `

mutation updateUserData($input: UserDataInput!) {
  updateUserData(input: $input) {
    ${userDataParams}
  }
}

`,
  upgradeToPro: `

mutation upgradeToPro($planId: String!, $token: String!) {
  upgradeToPro(planId: $planId, token: $token) {
    ${userDataParams}
  }
}

`,
  createGroup: `


  mutation CreateGroup($currency: String!, $name: String!, $participants: [String!]) {
  createGroup(currency: $currency, name: $name, participants: $participants) {
    ${groupParams}
  }
}
  
`,
  createGroupFromWeb: `


  mutation CreateGroupFromWeb($name: String!, $currency: String) {
  createGroupFromWeb(name: $name, currency: $currency) {
    ${groupParams}
  }
}
  
`,
  deleteExpense: `

    mutation DeleteExpense($expenseId: String!, $groupId: String!) {
  deleteExpense(expenseId: $expenseId, groupId: $groupId) {
    ${groupParams}
  }
}
  
`,
  changeBaseCurrency: `

    mutation ChangeBaseCurrency($groupId: String!, $currency: String!) {
  changeBaseCurrency(groupId: $groupId, currency: $currency) {
    ${groupParams}
  }
}
  
`,
  bindParticipantToUser: `

      mutation BindParticipantToUser( $groupId: String!, $participant: Int!) {
  bindParticipantToUser(groupId: $groupId, participant: $participant,) {
    ${groupParams}
  }
}
  
`,
  linkParticipants: `

    mutation LinkParticipants($groupId: String!, $participants: [Int!]) {
  linkParticipants(groupId: $groupId, participants: $participants) {
    ${groupParams}
  }
}
  
`,
  linkSingleParticipant: `

    mutation LinkSingleParticipant($groupId: String!, $participant: Int!,
       $linkedParticipantsIndex: Int!) {
  linkSingleParticipant(groupId: $groupId, participant: $participant,
    linkedParticipantsIndex: $linkedParticipantsIndex ) {
    ${groupParams}
  }
}
  
`,
  unlinkParticipants: `

    mutation UnlinkParticipants($groupId: String!, $participants: [Int!]) {
  unlinkParticipants(groupId: $groupId, participants: $participants) {
    ${groupParams}
  }
}
  
`,
  unlinkSingleParticipant: `

    mutation UnlinkSingleParticipant($groupId: String!, $participant: Int!) {
  unlinkSingleParticipant(groupId: $groupId, participant: $participant) {
    ${groupParams}
  }
}
  
`,
  addParticipant: `

    mutation AddParticipant( $groupId: String!, $name: String!) {
  addParticipant(groupId: $groupId, name: $name,) {
    ${groupParams}
  }
}
  
`,
  removeParticipant: `

    mutation RemoveParticipant( $groupId: String!, $participant: Int!) {
  removeParticipant(groupId: $groupId, participant: $participant,) {
    ${groupParams}
  }
}
  
`,
  renameParticipant: `

    mutation RenameParticipant( $groupId: String!, $participant: Int!, $name: String!) {
  renameParticipant(groupId: $groupId, participant: $participant, name: $name) {
    ${groupParams}
  }
}
  
`,
  archive: `

    mutation Archive( $groupId: String!) {
  archive(groupId: $groupId) {
    ${groupParams}
  }
}
  
`,
  unarchive: `

    mutation Unarchive( $timestamp: AWSTimestamp!) {
  unarchive(timestamp: $timestamp) {
    timestamp
    groupId
    summary {
      ${summaryParams}
    }
  }
}
  
`,
  removeFromArchive: `

    mutation RemoveFromArchive( $timestamp: AWSTimestamp!) {
  removeFromArchive(timestamp: $timestamp)
}
  
`,
  renameGroup: `

    mutation RenameGroup( $groupId: String!, $name: String!) {
  renameGroup(groupId: $groupId, name: $name) {
    ${groupParams}
  }
}
  
`,
  addExpense: `

mutation AddExpense($groupId: String, $input: AddExpenseInput!, $participants: [String]) {
  addExpense(groupId: $groupId, input: $input, participants: $participants) {
    ${groupParams}
  }
}
  
`,
  setGroupSettings: `

mutation SetGroupSettings($groupId: String!, $input: GroupSettingsInput!) {
  setGroupSettings(groupId: $groupId, input: $input) {
    ${groupParams}
  }
}
  
`,
  addSettledEntry: `

mutation AddSettledEntry($groupId: String!, $input: SettledEntryInput!) {
  addSettledEntry(groupId: $groupId, input: $input) {
    ${groupParams}
  }
}
  
`,
  updateItemsInExpense: `

mutation UpdateItemsInExpense($input: UpdateItemsInput!) {
  updateItemsInExpense(input: $input) {
    ${groupParams}
  }
}
  
`,
  createExpenseFromReceipt: `

mutation CreateExpenseFromReceipt($groupId: String, $imageId: String, $description: String, $imageBase64: String) {
  createExpenseFromReceipt(groupId: $groupId, imageId: $imageId, description: $description, imageBase64: $imageBase64) {
    ${groupParams}
  }
}
  
`,
  getGroup: `

query GetGroup($groupId: ID!) {
  getGroup(groupId: $groupId) {
    ${groupParams}
  }
}


`,
  notifyGroup: `

query NotifyGroup($groupId: String!) {
  notifyGroup(groupId: $groupId) {
    ${groupParams}
  }
}


`,
  getHistoryEvents: `

  query GetHistoryEvents($groupId: String!, $lastEvaluatedKey: String) {
     getHistoryEvents(groupId: $groupId, lastEvaluatedKey: $lastEvaluatedKey) {
        events {
          action
          data
          timestamp
        }
        lastEvaluatedKey
     }
  }
  
`,
  getArchives: `

  query GetArchives($lastEvaluatedKey: String) {
     getArchives(lastEvaluatedKey: $lastEvaluatedKey) {
        items {
          summary {
            ${summaryParams}
          }
          groupId
          timestamp
        }
        lastEvaluatedKey
     }
  }
  
`,
  getExpenseImageUrl: `

  query GetExpenseImageUrl($groupId: String!, $expenseId: String!) {
     getExpenseImageUrl(groupId: $groupId, expenseId: $expenseId)
  }
  
`,
  getExportSignedUrl: `

  query GetExportSignedUrl($groupId: String!) {
     getExportSignedUrl(groupId: $groupId)
  }
  
`,
  getPublicUserData: `

query GetPublicUserData($userId: String!) {
  getPublicUserData(userId: $userId) {
    ${userDataParams}
  }
}

`,
  getUserData: `

query GetUserData {
  getUserData {
    ${userDataParams}
  }
}

`,
  loginWithGoogle: `

query LoginWithGoogle($idToken: String!, $isIOS: Boolean) {
   loginWithGoogle(idToken: $idToken, isIOS: $isIOS) {
    username
    password
  }
} 


`,
  getReceiptUploadUrl: `

query GetReceiptUploadUrl {
   getReceiptUploadUrl {
      imageId
      signedUrl
      fields
  }
} 


`,
  getGroups: `

query GetGroups($groupIds: [ID]!) {
  getGroups(groupIds: $groupIds) {
    ${groupParams}
  }
}


`,
  getGroupSummaries: `

query GetGroupSummaries($limit: Int, $nextToken: String) {
  getGroupSummaries(limit: $limit, nextToken: $nextToken) {
    items {
      groupId
      groupSummary {
        ${summaryParams}
      }
    }
    nextToken
  }
}


`,
  refreshGroups: `

query RefreshGroups($groupIds: [String!]!, $versions: [Int!]!) {
  refreshGroups(groupIds: $groupIds, versions: $versions) {
    ${groupParams}
  }
}


`,
  sendGroupMagicLink: `

mutation SendGroupMagicLink($email: String!, $groupIds: [String!]!) {
  sendGroupMagicLink(email: $email, groupIds: $groupIds)
}

`,
};

export const subscriptions = {
  healthCheck: `

    subscription healthCheck { 
      healthCheck
    }
  
`,
  onGroupChange: `

subscription OnGroupChange($groupId: String!) {
  onGroupChange(id: $groupId) {
    ${groupParams}
  }
}
  
`,
};
